<div class="pt-4 flex flex-col gap-4">
  @for (block of contentBlocks(); track $index) {
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ 'waters.information.content-block' | translate }} {{ $index + 1 }}</mat-card-title>
        <div class="flex-1"></div>
        <button
          mat-icon-button
          type="button"
          color="warn"
          [aria-label]="'generic.remove' | translate"
          [matTooltip]="'generic.remove' | translate"
          (click)="removeContentBlock($index)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content class="!pt-4 flex flex-col gap-4">
        <mat-form-field>
          <mat-label>{{ 'waters.information.content-block.type' | translate }}</mat-label>
          <mat-select [value]="block.type" (selectionChange)="setType($index, $event.value)">
            <mat-option value="text">{{ 'waters.information.content-block.type.text' | translate }}</mat-option>
            <mat-option value="video">{{ 'waters.information.content-block.type.video' | translate }}</mat-option>
            <mat-option value="iframe">{{ 'waters.information.content-block.type.iframe' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>

        <p class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ 'waters.information.content-block.image' | translate }}</p>
        <app-image-field
          [currentImageName]="getPendingImageName(block) ?? block.imageName"
          [currentImageUrl]="getPendingImageUrl(block) ?? block.imageUrl ?? null"
          (fileSelected)="selectImage($index, $event)"
          (cleared)="clearImage($index)"
        />
      </mat-card-content>
    </mat-card>
  }
  <button mat-stroked-button type="button" class="self-start" (click)="addContentBlock()">
    <mat-icon>add</mat-icon>
    {{ 'waters.information.add-content-block' | translate }}
  </button>
</div>
